import { SVGProps, Ref, forwardRef } from 'react';

export const ENSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect y={3} width={24} height={18} rx={3} fill="#22408C" />
            <path
                d="M9.12 7.59 3 3C1.58 3 .392 3.986.08 5.31l5.08 3.81H0v5.76h5.16L.08 18.69A3 3 0 0 0 3 21l6.12-4.59V21h5.76v-4.59L21 21c1.42 0 2.608-.986 2.92-2.31l-5.08-3.81H24V9.12h-5.16l5.08-3.81A3 3 0 0 0 21 3l-6.12 4.59V3H9.12z"
                fill="#EEEEEE"
            />
            <path d="M23.081 3.84 16.04 9.12h-1.16v-.93l6.813-5.11a3 3 0 0 1 1.388.76" fill="#CF1B2B" />
            <path d="M.238 4.828 5.96 9.12h2.4L1.102 3.677a3 3 0 0 0-.864 1.151" fill="#CF1B2B" />
            <path d="M9.12 14.88v.93l-6.813 5.11a3 3 0 0 1-1.388-.76l7.041-5.28z" fill="#CF1B2B" />
            <path d="M22.898 20.323c.374-.306.673-.7.864-1.151L18.04 14.88h-2.4z" fill="#CF1B2B" />
            <path d="M13.8 13.8V21h-3.6v-7.2H0v-3.6h10.2V3h3.6v7.2H24v3.6z" fill="#CF1B2B" />
        </g>
    </svg>
));
ENSize24Glyph.displayName = 'ENSize24Glyph';
